import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './lib/runtime-compat';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import { FeatureFlagProvider } from './contexts/featureFlagContext';
import { applyBundleOverrideFromURL } from './lib/bundleOverride';
import { loadRuntimeConfig } from './lib/connect/runtimeConfig';
import { initRemoteCatalog } from './lib/tool-configs/remote';
import { CSPostHogProvider, ReactQueryProvider } from './providers';
import router from './router';
import './lib/tiptap-dispatch-compat';
import './globals.css';
/**
 * Get the root DOM element and validate its existence
 */ // Before anything else: if the URL pins a bundle this navigates away, and the
// rest of boot belongs to the pinned build rather than this one. Guarding the
// render rather than throwing — an uncaught error here would be indistinguishable
// from a real boot failure, in the console and to the UX gates.
const reloadingIntoPinnedBundle = applyBundleOverrideFromURL();
const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Failed to find the root element');
}
/**
 * Load runtime config (e.g. sabaody gateway URL) from express-backend
 * before rendering so the Connect transport gets the correct baseUrl.
 * Warm the agent tool catalog from sessionStorage and kick a background
 * refresh against shanks so the first tool card render has display data
 * (no-op unless REACT_APP_USE_REMOTE_CATALOG=1).
 */ if (!reloadingIntoPinnedBundle) {
    loadRuntimeConfig().then(()=>{
        initRemoteCatalog();
        ReactDOM.createRoot(rootElement).render(/*#__PURE__*/ _jsx(React.StrictMode, {
            children: /*#__PURE__*/ _jsx(HelmetProvider, {
                children: /*#__PURE__*/ _jsx(ReactQueryProvider, {
                    children: /*#__PURE__*/ _jsx(FeatureFlagProvider, {
                        children: /*#__PURE__*/ _jsxs(CSPostHogProvider, {
                            children: [
                                /*#__PURE__*/ _jsx(RouterProvider, {
                                    router: router
                                }),
                                /*#__PURE__*/ _jsx(Toaster, {
                                    position: "top-center",
                                    expand: true,
                                    richColors: true,
                                    toastOptions: {
                                        style: {
                                            fontSize: '16px',
                                            padding: '16px'
                                        },
                                        classNames: {
                                            error: 'bg-red-600 text-white border-red-700',
                                            success: 'bg-green-600 text-white border-green-700',
                                            warning: 'bg-yellow-600 text-white border-yellow-700',
                                            info: 'bg-blue-600 text-white border-blue-700'
                                        }
                                    }
                                })
                            ]
                        })
                    })
                })
            })
        }));
    });
}
